import { createAction, props } from '@ngrx/store';
import { AdminManageGetNotificationsGet$Params } from '../../generated/auth/fn/admin/admin-manage-get-notifications-get';
import { ApiResponseOfSasfinWealthOnlineBlModelsPagedResultOfWealthOnlineSharedDataModelsNotification } from '../../generated/auth/models/Sasfin/Wealth/Online/Api/Models/Responses/api-response-of-sasfin-wealth-online-bl-models-paged-result-of-wealth-online-shared-data-models-notification';

// Load notifications
export const loadNotifications = createAction('[External Notification] Load Notifications');

export const loadNotificationsSuccess = createAction(
  '[External Notification] Load Notifications (Success)',
  props<{ response: ApiResponseOfSasfinWealthOnlineBlModelsPagedResultOfWealthOnlineSharedDataModelsNotification }>(),
);

export const loadNotificationsFailure = createAction(
  '[External Notification] Load Notifications (Failure)',
  props<{ error: any }>(),
);

// Filter actions
export const setFilter = createAction(
  '[External Notification] Set Filter',
  props<{ filter: AdminManageGetNotificationsGet$Params }>(),
);

export const clearFilter = createAction('[External Notification] Clear Filter');

export const updatePagination = createAction(
  '[External Notification] Update Pagination',
  props<{ page: number; pageSize: number }>(),
);
